import { useCallback } from 'react'
import { apiCall, ApiConfig } from '../../../config/api'
import {
  WorkOrderInBoundLocate,
  WorkOrderInboundSkuHistoryDetails
} from '../../../interfaces/WorkOrder/WorkOrder'
import { usePutAway } from '../Context/usePutAway'
import { actionTypes } from '../types/actionTypes'
import { putAwayConst } from '../const/putAwayConst'
import { AxiosResponse } from 'axios'
import {
  originUnknown,
  StatusGenericInput,
  supplierUnknown
} from '../types/reducerTypes'
import { FilterdItems } from '../../../interfaces/Generic/State'
import { stepperTypes } from '../types/stepperTypes'
import { useUser } from '../../../hooks/useUser'
import { useConfiguration } from '../../../hooks/useConfiguration'
import { FlipBackOptions, LpnState } from '../types/enums'
import { asnFinishedStates } from '../../../enums/eAsnState'
import { eTypeStorage } from '../../../enums/eTypeStorage'
import { eBatchState } from '../../../enums/eBatch'
import { ConfigurationSaga } from '../../../interfaces/Configuration/Configuration'
import { Batch } from '../../../interfaces/Batch'
import { SkuFefoType } from '../../_WMS/ListBatch/SkuFefoType'
import { getAsnBatches } from '../screens/LocateSKUPutAway/FefoModal/api'

type SetInputType =
  | 'setInputQty'
  | 'setUbication'
  | 'setSkuEan'
  | 'setSkuUnknown'
type SetInputName = 'inputQty' | 'ubication' | 'skuEan' | 'skuUnknown'

// Se crean dos metodos o fuciones para realizar las diferentes acciones
// en el state del reducer como: incrementar y decrementar

/*
Copyright 2022-04-08 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega validación de SKU

Copyright 2022-04-08 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega funcionalidad para agregar SKU escaneados a estado global

Copyright 2022-04-13 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega método 'Terminar Ubicación' en la validación de SKU,
de modo que se ejecute cuando un usuario agrega la posición en el input de SKU
*/
/*
Copyright 2022-06-14 por Miguel Balloqui Ecomsur Holding S.A ©
Detalle: Modifica linea 345 "positionName por positionCode"

Copyright 2023-09-11 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se agrega parámetro por configuración para cambiar ingreso por cantidad
o ingreso unidad por únidad
*/
export const putAwayActions = () => {
  const { state, dispatch } = usePutAway()
  const { options } = putAwayConst()
  const {
    userDataState: { userData }
  } = useUser()

  const { configurationState } = useConfiguration()

  const setLastSearchedBy = (field: string): actionTypes => ({
    type: 'setLastSearchedBy',
    payload: field
  })

  const setSearch = (field: string): actionTypes => ({
    type: 'setSearch',
    payload: field
  })

  // selector para busqueda recepción de devoluciones
  const setHeaderParamSearch = (field: string): actionTypes => ({
    type: 'setHeaderParamSearch',
    payload: field
  })

  const setTitlteDocsMatch = (field: string): actionTypes => ({
    type: 'setTitlteDocsMatch',
    payload: field
  })
  const setSuppliersUnknown = (value: supplierUnknown[]): actionTypes => ({
    type: 'setSuppliersUnknown',
    payload: value
  })
  const setOriginsUnknown = (value: originUnknown[]): actionTypes => ({
    type: 'setOriginsUnknown',
    payload: value
  })
  const setIsUnknownScreen = (value: boolean): actionTypes => ({
    type: 'setIsUnknownScreen',
    payload: value
  })
  const setUnknownFilter = (value: number): actionTypes => ({
    type: 'setUnknownFilter',
    payload: value
  })
  const setShowFefoModal = (value: boolean): actionTypes => ({
    type: 'setShowFefoModal',
    payload: value
  })
  const setSelectedBatchId = (value: number | undefined): actionTypes => ({
    type: 'setSelectedBatchId',
    payload: value
  })
  const setBachList = (value: Batch): actionTypes => ({
    type: 'setBachList',
    payload: value
  })
  const setSkuFefoType = (value: SkuFefoType): actionTypes => ({
    type: 'setSkuFefoType',
    payload: value
  })

  const resetButtonFilter = (value: number) => {
    dispatch(setWorkOrderLocate([]))
    handleResetGenericInput('setSkuUnknown')
    dispatch(setUnknownFilter(value))
  }

  const setSearchValue = (value: string): actionTypes => ({
    type: 'setSearchValue',
    payload: value
  })

  const setWorkOrderLocate = (
    value: WorkOrderInBoundLocate[]
  ): actionTypes => ({
    type: 'setWorkOrderLocate',
    payload: value
  })

  const setItem = (value: WorkOrderInBoundLocate): actionTypes => ({
    type: 'setItem',
    payload: value
  })

  const setError = (
    error: string,
    status: StatusGenericInput
  ): actionTypes => ({
    type: 'setError',
    payload: {
      error,
      status
    }
  })

  const setStep = (value: number): actionTypes => ({
    type: 'setStep',
    payload: value
  })

  const setLoading = (value: boolean): actionTypes => ({
    type: 'setLoading',
    payload: value
  })

  const setResetState = (): actionTypes => ({
    type: 'setResetState'
  })
  const setInputValue = (
    value: string,
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type: type,
    payload: {
      ...state[name],
      value: value
    }
  })
  const setInputError = (
    error: string,
    status: StatusGenericInput,
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type: type,
    payload: {
      ...state[name],
      status,
      error
    }
  })

  const setResetPageState = (): actionTypes => ({
    type: 'setResetPageState'
  })

  const handleResetPage = () => {
    dispatch(setResetPageState())
    document.getElementById('ubication')?.focus()
  }

  const setResetInput = (type: SetInputType): actionTypes => ({
    type,
    payload: {
      value: '',
      status: 'default',
      error: ''
    }
  })

  const setDefaultStatusInput = (
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type,
    payload: {
      ...state[name],
      status: 'default'
    }
  })

  const setViewField = (field: string): actionTypes => ({
    type: 'setViewField',
    payload: field
  })

  const setInputData = (
    value: string,
    error: string,
    status: StatusGenericInput,
    type: SetInputType
  ): actionTypes => ({
    type: type,
    payload: {
      value,
      error,
      status
    }
  })

  const handleChangeGenericInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    type: SetInputType
  ) => {
    dispatch(setError('', 'default'))
    const name = e.target.name as SetInputName
    if (type === 'setInputQty') {
      if (parseInt(e.target.value) > 0) {
        dispatch(setInputData(e.target.value, '', 'success', 'setInputQty'))
      } else {
        dispatch(
          setInputData('', 'La cantidad no es válida', 'error', 'setInputQty')
        )
      }
      return
    }
    dispatch(setInputValue(e.target.value, type, name))
  }

  const handleResetGenericInput = (type: SetInputType) => {
    dispatch(setResetInput(type))

    // Limpiar selectedBatchId cuando se resetea el SKU
    if (type === 'setSkuEan') {
      dispatch(setSelectedBatchId(undefined))
    }
  }

  const mapperSearchOptions = () => {
    return options.find((x) => x.value === state.isSelected)?.name.toUpperCase()
  }

  const mapperDetailsOptions = (item: WorkOrderInBoundLocate) => {
    let option = ''
    let itemField = ''
    option = options.find((x) => x.value === state.isSelected)?.label!

    if (option === 'OT') {
      itemField = item.workOrderId.toString()
    } else {
      if (option === 'ASN') {
        itemField = item.asnNumber.toString()
      } else {
        itemField = item.workingLpn
      }
    }

    return `${option} ${itemField}`
  }

  const validateoldWayStepBack = (
    step: number,
    workOrderInboundLocate: WorkOrderInBoundLocate[]
  ) => {
    if (step === stepperTypes.stepDocsMatchPutAway) {
      dispatch(setStep(stepperTypes.stepSearchPutAway))
      dispatch(setResetState())
    }

    if (
      step === stepperTypes.stepDescriptionPutAway &&
      workOrderInboundLocate.length > 1
    ) {
      dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
    }

    if (
      step === stepperTypes.stepDescriptionPutAway &&
      workOrderInboundLocate.length === 1
    ) {
      dispatch(setResetState())
      dispatch(setStep(stepperTypes.stepSearchPutAway))
    }

    if (
      step === stepperTypes.stepLocateHistoryPutAway &&
      state.SkuListOnPosition.length === 0
    ) {
      dispatch(setStep(stepperTypes.stepDescriptionPutAway))
    }

    if (
      step === stepperTypes.stepLocateHistoryPutAway &&
      state.SkuListOnPosition.length > 0
    ) {
      dispatch(setIsShowNotification(true))
    }

    if (step === stepperTypes.stepLPNSelection) {
      dispatch(setStep(stepperTypes.stepSearchPutAway))
    }
  }

  const validateUnknownStepBack = (step: number) => {
    if (step === stepperTypes.stepLPNSelection) {
      dispatch(setStep(stepperTypes.stepUnknowOt))
      return
    }

    if (step === stepperTypes.stepUnknowOt) {
      dispatch(setIsUnknownScreen(false))
      dispatch(setStep(stepperTypes.stepSearchPutAway))
    }
    if (
      step === stepperTypes.stepDescriptionPutAway &&
      state.unknownFilter <= 2
    ) {
      dispatch(setStep(stepperTypes.stepUnknowOt))
    }
    if (
      step === stepperTypes.stepDescriptionPutAway &&
      state.unknownFilter > 2 &&
      state.workOrderInboundLocate.length > 1
    ) {
      dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
    }
    if (
      step === stepperTypes.stepDescriptionPutAway &&
      state.unknownFilter > 2 &&
      state.workOrderInboundLocate.length === 1
    ) {
      dispatch(setStep(stepperTypes.stepUnknowOt))
    }
    if (step === stepperTypes.stepLocateHistoryPutAway) {
      dispatch(setStep(stepperTypes.stepDescriptionPutAway))
    }
    if (step === stepperTypes.stepDocsMatchPutAway) {
      dispatch(setStep(stepperTypes.stepUnknowOt))
    }
  }
  const validateStepBack = (
    step: number,
    workOrderInboundLocate: WorkOrderInBoundLocate[]
  ) => {
    if (state.isUnknownScreen) {
      validateUnknownStepBack(step)
    } else {
      validateoldWayStepBack(step, workOrderInboundLocate)
    }
  }

  const validateStep = (response: AxiosResponse) => {
    if (response.data.length > 1) {
      return dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
    }

    if (response.data.length === 1) {
      if (asnFinishedStates.includes(response.data[0].asnStateId)) {
        dispatch(
          setError(
            `${mapperSearchOptions()} ${response.data[0].asnStateName}`,
            'success'
          )
        )
      } else {
        dispatch(setError('', 'default'))
        const workOrder: WorkOrderInBoundLocate = response.data[0]

        dispatch(setItem(workOrder))

        // Si retorna solo 1 registro ira a la pantalla directo. por lo que se valida que no esté bloqueada la lpn "lpnBloqued"
        if (
          workOrder.lpn.length > 1 ||
          (workOrder.lpn.length === 1 &&
            workOrder.lpn[0].lpnStateId === LpnState.Manage)
        ) {
          dispatch(setSearch('Lpn'))
          return dispatch(setStep(stepperTypes.stepLPNSelection))
        }
        if (workOrder.lpnBloqued.length === 1) {
          dispatch(setError('LPN ya se encuentra en uso.', 'error'))
        } else {
          return dispatch(setStep(stepperTypes.stepDescriptionPutAway))
        }
      }
    }
  }

  const getWorkOrderLocateByLpn = (lpn: string, asnNumber: string) => {
    dispatch(setLoading(true))
    apiCall(
      'GET',
      `${ApiConfig.InboundApi}/GetWorkOrderLocate?LPN=${lpn}&AsnNumber=${asnNumber}&WorkOrderId=${state.item?.workOrderId}`
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderLocate([]))
          dispatch(setError('No fue posible obtener los datos', 'error'))
        } else {
          // Si estamos buscando por LPN, a esta altura ya seleccionamos una ASN
          // El método, sin embargo, nos va a devolver todos los resultados para
          // la ASN X y LPN Y (el AsnNumber se puede repetir y el contenedor igual, entre distintas ASNs)
          const foundedElements = response.data as WorkOrderInBoundLocate[]
          // Filtramos la ASN que ya fue previamente seleccionada
          const correctElement = foundedElements.filter(
            (el) => el.asnId === state.item?.asnId
          )[0]
          dispatch(setItem(correctElement))
          return dispatch(setStep(stepperTypes.stepDescriptionPutAway))
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderLocate([]))
        dispatch(setError(message, 'error'))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const getWorkOrderLocate = (psearch?: string, pvalue?: string) => {
    // Llama al metodo solo si esta desactivada la opcion "Permite más de un operador por LPN"
    const allowTwoUserOnTheSameLPN = configurationState.configuration.filter(
      (el) => el.name === 'AllowTwoUserOnTheSameLPN'
    )[0]

    const paramSearch = !psearch ? state.isSelected : psearch
    const valueSearch = !pvalue ? state.searchValue : pvalue

    dispatch(setLoading(true))
    apiCall(
      'GET',
      `${
        ApiConfig.InboundApi
      }/GetWorkOrderLocate?${paramSearch}=${valueSearch}${
        !!allowTwoUserOnTheSameLPN.value &&
        userData?.userId &&
        '&userId=' + userData?.userId.toString()
      }`
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderLocate([]))
          dispatch(setError('No fue posible obtener los datos', 'error'))
        } else {
          if (paramSearch === 'AsnNumber' || paramSearch === 'WorkOrderId') {
            if (response.data && response.data[0]?.lpn.length > 1) {
              dispatch(setLastSearchedBy(paramSearch)) // newchange
            } else {
              dispatch(setLastSearchedBy(''))
            }
          }

          dispatch(setWorkOrderLocate(response.data))
          validateStep(response)
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderLocate([]))
        dispatch(setError(message, 'error'))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const setUserId = (id: number): actionTypes => ({
    type: 'setUserId',
    payload: id
  })

  const handleSetUserId = (id: number) => dispatch(setUserId(id))

  const terminateLocateAsn = (lpnStateId?: number, finishLPN?: boolean) => {
    dispatch(setLoading(true))
    setTypePosition(0)
    const { item, positionId, SkuListOnPosition } = state
    const asnLocatedSkusDto = SkuListOnPosition.map((sku) => ({
      skuId: sku.skuId,
      locatedQty: sku.value,
      batchId: sku.batchId || undefined
    }))

    apiCall('POST', `${ApiConfig.InboundApi}/TerminateLocateASN`, {
      workOrderId: item?.workOrderId,
      asnId: item?.asnId,
      // Si la ASN no posee LPN, esto debe ir vacio
      // Si la ASN posee LPN, la ubicación de mercadería se hace por LPN (1 por 1)
      // De este modo, siempre se está trabajando el LPN seleccionado o ninguno
      lpn: item?.lpn ? item.workingLpn : '',
      positionId: positionId,
      userId: userData?.userId,
      lpnStateId: lpnStateId,
      externalStorage: item?.externalStorage,
      asnLocatedSkusDto,
      finishLPN
    })
      .then((response: AxiosResponse) => {
        if (asnFinishedStates.includes(response.data[0].asnStateId)) {
          dispatch(
            setError(`ASN ${response.data[0].asnNumber} Finalizada`, 'success')
          )

          dispatch(setSearchValue(''))
          dispatch(setStep(stepperTypes.stepSearchPutAway))
          setTimeout(() => {
            dispatch(setResetState())
          }, 3500)
        } else {
          dispatch(setItem(response.data[0]))
          getWorkOrderSkuHistory()
          recalculateItems()
          // mismo de lpn state
          if (lpnStateId) {
            state.isSelected = 'WorkOrderId'
            state.searchValue = state.item?.workOrderId.toString() || ''
            dispatch(setStep(stepperTypes.stepLPNSelection))
            dispatch(setError('', 'default'))
          }

          if (
            response.data &&
            response.data[0].lpn.find((x: any) => x.lpn === item?.workingLpn)
              .lpnStateId === LpnState.Finished
          ) {
            dispatch(setStep(stepperTypes.stepLPNSelection))
            dispatch(setError('', 'default'))
          }
        }
        dispatch(setLoading(false))
      })
      .catch(({ data: { message } }) => {
        dispatch(setError(message, 'error'))
      })
      .finally(() => dispatch(setLoading(false)))
    handleResetPage()
    dispatch(setCalculatedExcess(0))
  }

  const setPositionId = (position: number): actionTypes => ({
    type: 'setPositionId',
    payload: position
  })

  const setPosition = (positionId: number) =>
    dispatch(setPositionId(positionId))

  const setTypePositionId = (typePosition: number): actionTypes => ({
    type: 'setTypePositionId',
    payload: typePosition
  })

  const setTypePosition = (positionId: number) =>
    dispatch(setTypePositionId(positionId))

  const validatePosition = (
    e: React.FormEvent<HTMLFormElement>,
    positionCode: string,
    isReserve: boolean,
    isPreSale: boolean
  ) => {
    const { item } = state
    e.preventDefault()
    setTypePosition(0)
    if (state.ubication.value.length > 0) {
      e.preventDefault()
      apiCall(
        'GET',
        `${ApiConfig.InboundApi}/ValidatePosition/${positionCode}/${
          item?.typeStorageId || eTypeStorage.Interno
        }?isReserve=${isReserve}&isPreSale=${isPreSale}`
      )
        .then((response: AxiosResponse) => {
          if (response.data) {
            setPosition(parseInt(response.data.positionId))
            setTypePosition(parseInt(response.data.typePositionId))
            dispatch({
              type: 'setUbication',
              payload: {
                ...state.ubication,
                error: '',
                status: 'success'
              }
            })
          }
        })
        .catch(({ data: { message } }) => {
          dispatch({
            type: 'setUbication',
            payload: {
              ...state.ubication,
              error: message,
              status: 'error'
            }
          })
        })
    } else {
      dispatch(
        setInputError(
          'La posición no es válida',
          'error',
          'setUbication',
          'ubication'
        )
      )
    }
  }

  const expandCollapseHeaderAndGrid = () => {
    const containerHeaderPutAway = document.getElementById(
      'containerHeaderPutAway'
    )!
    const containerGridPutAway = document.getElementById(
      'containerGridPutAway'
    )!
    const wrapper = document.querySelector('.wrapperHeader')!

    const containerDetails = document.getElementById('containerDetails')!

    if (
      containerHeaderPutAway.clientHeight === 140 ||
      containerHeaderPutAway.clientHeight === 170
    ) {
      containerHeaderPutAway.style.height = state.isExcess ? '260px' : '220px'

      if (containerGridPutAway !== null) {
        containerGridPutAway.style.height = state.isExcess ? '20px' : '100px'
      }
      containerDetails.style.height = '80px'
    } else {
      containerHeaderPutAway.style.height = wrapper.clientHeight + 'px'
      if (containerGridPutAway !== null) {
        containerGridPutAway.style.height = '100px'
      }
      containerDetails.style.height = '0px'
    }
  }

  const addOneToOneElementToSKUList = (
    shouldAddElementToList: boolean,
    batchId?: number
  ) => {
    if (shouldAddElementToList && state.inputQty.status !== 'error') {
      const existSKUOnList = state.SkuListOnPosition.find((item) => {
        const skuMatches = item.sku === state.skuEan.value
        if (batchId !== undefined) {
          return skuMatches && item.batchId === batchId
        }
        return (
          skuMatches && (item.batchId === undefined || item.batchId === null)
        )
      })

      const skuObject = getElegibleProducts(state.skuEan.value)[0]

      if (existSKUOnList) {
        const newElement = {
          ...existSKUOnList,
          value: 1 + parseInt(existSKUOnList.value.toString())
        }
        dispatch(addItemList(newElement))
      } else {
        dispatch(
          addItemList({
            skuId: skuObject.skuId,
            productName: skuObject.skuName,
            sku: skuObject.sku,
            value: 1,
            batchId: batchId
          })
        )
      }
      dispatch(setSkuLocated(skuObject.skuName))

      // Verificar si se completó un lote después de agregar el elemento
      if (batchId) {
        // Calcular la nueva cantidad considerando lo que se acaba de agregar
        const newQtyForThisBatch = existSKUOnList
          ? 1 + parseInt(existSKUOnList.value.toString())
          : 1

        if (
          checkBatchCompletionWithNewQty(
            batchId,
            newQtyForThisBatch,
            existSKUOnList
          )
        ) {
          handleBatchCompletion(batchId)
        }
      }

      // Setear input
      handleResetGenericInput('setSkuEan')
      handleResetGenericInput('setInputQty')
    }
  }

  const addElementToSKUList = (
    event: React.KeyboardEvent<HTMLDivElement>,
    batchId?: number
  ) => {
    if (event.key === 'Enter' && state.inputQty.status !== 'error') {
      const existSKUOnList = state.SkuListOnPosition.find((item) => {
        const skuMatches = item.sku === state.skuEan.value
        if (batchId !== undefined) {
          return skuMatches && item.batchId === batchId
        }
        return (
          skuMatches && (item.batchId === undefined || item.batchId === null)
        )
      })

      const skuObject = getElegibleProducts(state.skuEan.value)[0]

      if (existSKUOnList) {
        const newElement = {
          ...existSKUOnList,
          value:
            parseInt(state.inputQty.value) +
            parseInt(existSKUOnList.value.toString())
        }
        dispatch(addItemList(newElement))
      } else {
        dispatch(
          addItemList({
            skuId: skuObject.skuId,
            productName: skuObject.skuName,
            sku: skuObject.sku,
            value: parseInt(state.inputQty.value),
            batchId: batchId
          })
        )
      }
      dispatch(setSkuLocated(skuObject.skuName))

      // Verificar si se completó un lote después de agregar el elemento
      if (batchId) {
        // Calcular la nueva cantidad considerando lo que se acaba de agregar
        const newQtyForThisBatch = existSKUOnList
          ? parseInt(state.inputQty.value) +
            parseInt(existSKUOnList.value.toString())
          : parseInt(state.inputQty.value)

        if (
          checkBatchCompletionWithNewQty(
            batchId,
            newQtyForThisBatch,
            existSKUOnList
          )
        ) {
          handleBatchCompletion(batchId)
        }
      }

      // Setear input
      handleResetGenericInput('setSkuEan')
      handleResetGenericInput('setInputQty')
    }
  }

  const checkBatchCompletionWithNewQty = (
    batchId: number,
    newQtyForThisBatch: number,
    existingElement?: any
  ): boolean => {
    if (!state.item) {
      return false
    }

    // Obtener la información del lote desde workOrderDetails
    const batchDetails = state.item.workOrderDetails.filter(
      (detail) => detail.batchId === batchId
    )

    if (batchDetails.length === 0) {
      return false
    }

    // Calcular cantidad total requerida para este lote
    const totalRequiredQty = batchDetails.reduce(
      (total, detail) => total + (detail.realQty - detail.locatedQty),
      0
    )

    // Calcular cantidad existente en otros elementos (excluyendo el elemento que se está actualizando)
    const existingQtyForOtherElements = state.SkuListOnPosition.filter(
      (item) => {
        if (item.batchId !== batchId) return false
        // Si hay un elemento existente siendo actualizado, excluirlo del cálculo
        if (
          existingElement &&
          item.skuId === existingElement.skuId &&
          item.batchId === existingElement.batchId
        ) {
          return false
        }
        return true
      }
    ).reduce((total, item) => total + item.value, 0)

    const totalQtyAfterAddition =
      existingQtyForOtherElements + newQtyForThisBatch

    // Verificar si se alcanzó o superó la cantidad requerida
    return totalQtyAfterAddition >= totalRequiredQty
  }

  const handleBatchCompletion = (batchId?: number) => {
    if (!batchId || !state.selectedBatchList.has(batchId)) {
      return
    }

    // Evitar mostrar el modal si ya está abierto
    if (state.showBatchCompletedModal) {
      return
    }

    // Verificar si ya se mostró la notificación para este lote
    if (state.notifiedCompletedBatches.has(batchId)) {
      return
    }

    const batchInfo = state.selectedBatchList.get(batchId)
    const batchDisplayInfo = batchInfo?.batchNumber
      ? `Lote: ${batchInfo.batchNumber}`
      : `Lote ID: ${batchId}`

    // Marcar este lote como notificado
    dispatch({
      type: 'addNotifiedCompletedBatch',
      payload: batchId
    })

    setCompletedBatchInfo(batchId, batchDisplayInfo)
    setShowBatchCompletedModal(true)
  }

  const setShowBatchCompletedModal = (show: boolean) => {
    dispatch({
      type: 'setShowBatchCompletedModal',
      payload: show
    })

    // Si se está cerrando el modal, limpiar la información del lote completado y dar focus al campo SKU
    if (!show) {
      dispatch({
        type: 'setCompletedBatchInfo',
        payload: null
      })

      // Dar focus al campo SKU para continuar trabajando
      setTimeout(() => {
        document.getElementById('skuEan')?.focus()
      }, 100)
    }
  }

  const setCompletedBatchInfo = (batchId: number, batchInfo: string) => {
    dispatch({
      type: 'setCompletedBatchInfo',
      payload: { batchId, batchInfo }
    })
  }

  const resetNotifiedCompletedBatches = () => {
    dispatch({
      type: 'resetNotifiedCompletedBatches'
    })
  }

  const removeNotifiedCompletedBatch = (batchId: number) => {
    dispatch({
      type: 'removeNotifiedCompletedBatch',
      payload: batchId
    })
  }

  const addItemList = (newItem: FilterdItems): actionTypes => ({
    type: 'setItemList',
    payload: [
      ...state.SkuListOnPosition.filter(
        (item) =>
          !(item.skuId === newItem.skuId && item.batchId === newItem.batchId)
      ),
      newItem
    ]
  })

  const validateRemoveItemList = (field: string, batchId?: number) => {
    dispatch(setSkuLocated(''))
    if (state.isSelectedFieldView === 'skuId') {
      return state.SkuListOnPosition.filter((i) => {
        if (batchId !== undefined) {
          return !(i.sku === field && i.batchId === batchId)
        }
        return !(
          i.sku === field &&
          (i.batchId === undefined || i.batchId === null)
        )
      })
    }

    return state.SkuListOnPosition.filter((i) => {
      if (batchId !== undefined) {
        return !(i.productName === field && i.batchId === batchId)
      }
      return !(
        i.productName === field &&
        (i.batchId === undefined || i.batchId === null)
      )
    })
  }

  const checkAndRemoveBatchNotificationAfterDelete = (
    field: string,
    batchId?: number
  ) => {
    if (!batchId || !state.item) return

    // Simular la eliminación para ver cómo quedaría la lista
    const listAfterDeletion = validateRemoveItemList(field, batchId)

    // Verificar si después de la eliminación, el lote ya no está completo
    const batchDetails = state.item.workOrderDetails.filter(
      (detail) => detail.batchId === batchId
    )

    if (batchDetails.length === 0) return

    // Calcular cantidad total requerida para este lote
    const totalRequiredQty = batchDetails.reduce(
      (total, detail) => total + (detail.realQty - detail.locatedQty),
      0
    )

    // Calcular cantidad que quedaría después de la eliminación
    const remainingQtyAfterDeletion = listAfterDeletion
      .filter((item) => item.batchId === batchId)
      .reduce((total, item) => total + item.value, 0)

    // Si después de la eliminación el lote ya no está completo, remover la notificación
    if (
      remainingQtyAfterDeletion < totalRequiredQty &&
      state.notifiedCompletedBatches.has(batchId)
    ) {
      removeNotifiedCompletedBatch(batchId)
    }
  }

  const removeItemList = (field: string, batchId?: number): actionTypes => ({
    type: 'setItemList',
    payload: validateRemoveItemList(field, batchId)
  })

  const handleRemoveItemFromList = (field: string, batchId?: number) => {
    // Verificar si debemos remover la notificación del lote antes de eliminar
    checkAndRemoveBatchNotificationAfterDelete(field, batchId)

    // Ejecutar la eliminación
    dispatch(removeItemList(field, batchId))
  }

  const getElegibleProducts = (sku?: string) =>
    state.item
      ? state.item.workOrderDetails.filter((item) =>
          sku !== undefined ? item.sku === sku : true
        )
      : []

  const comparePositionWithSKU = (
    scannedPosition: string,
    scannedSKU: string
  ) => scannedPosition.toLowerCase() === scannedSKU.toLowerCase()

  const getSkuIdFromElegibleProducts = (sku: string) => {
    const allSku = getElegibleProducts()

    const getSkuId = allSku.filter((item) => item.sku === sku)[0].skuId

    return getSkuId
  }

  const validateSKUInput = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const isPutawayUnitByUnit = configurationState.configuration.filter(
      (el) => el.name === 'UnitaryPutaway'
    )[0]

    const {
      skuEan: { value: scannedSKU },
      ubication: { value: scannedPosition }
    } = state

    const isSkuEqualToPosition = comparePositionWithSKU(
      scannedSKU,
      scannedPosition
    )

    if (isSkuEqualToPosition) {
      if (state.isExcess) {
        dispatch(setIsShowExcess(true))
      } else {
        terminateLocateAsn()
      }
      return
    }

    const allSku = getElegibleProducts()

    const elegibleSKUs = allSku.map((el) => el.sku)

    if (elegibleSKUs.includes(state.skuEan.value)) {
      const idSku = getSkuIdFromElegibleProducts(state.skuEan.value)
      // validamos el SKU
      apiCall(
        'GET',
        `${ApiConfig.InboundApi}/ValidateSku?skuId=${idSku}&positionId=${state.positionId}`
      )
        .then((response: AxiosResponse) => {
          if (response.status !== 200) {
            handleSkuValidationErrorResponse(response)
          } else {
            handleSkuValidationSuccessResponse(
              response,
              isPutawayUnitByUnit,
              event
            )
          }
        })
        .catch(({ data: { message } }) => {
          dispatch(setInputError(message, 'error', 'setSkuEan', 'skuEan'))
        })

      return
    }

    dispatch(setInputError('SKU no es válido', 'error', 'setSkuEan', 'skuEan'))
  }

  const handleSkuValidationErrorResponse = (response: AxiosResponse) => {
    dispatch(
      setInputError(response.data.message, 'error', 'setSkuEan', 'skuEan')
    )
  }

  interface SkuAsnDetailValidated {
    stockKeepingUnitId: number
    sku: string
    externalStorage: boolean
    batchNumber: boolean
    expirationDate: boolean
  }

  /**
   * Filtra lotes que ya están completados en el frontend (sesión actual)
   * @param batches - Array de lotes obtenidos de la API
   * @returns Array de lotes que NO están completados
   */
  const filterCompletedBatchesInFrontend = (batches: Batch[]): Batch[] => {
    if (!state.item) {
      return batches
    }

    return batches.filter((batch) => {
      // Buscar información del lote en workOrderDetails
      const batchDetails = state.item!.workOrderDetails.filter(
        (detail) => detail.batchId === batch.batchId
      )

      if (batchDetails.length === 0) {
        // Si no hay información del lote, incluirlo (no lo filtramos)
        return true
      }

      // Calcular cantidad total pendiente para este lote (backend)
      const totalRequiredQty = batchDetails.reduce(
        (total, detail) => total + (detail.realQty - detail.locatedQty),
        0
      )

      // Calcular cantidad ubicada en el frontend para este lote
      const locatedQtyInFrontend = state.SkuListOnPosition.filter(
        (item) => item.batchId === batch.batchId
      ).reduce((total, item) => total + item.value, 0)

      // Si ya ubicamos todo lo pendiente en el frontend, el lote está completo
      const isCompleted = locatedQtyInFrontend >= totalRequiredQty

      // Retornar true para INCLUIR el lote (no está completo), false para EXCLUIR (está completo)
      return !isCompleted
    })
  }

  const handleSkuValidationSuccessResponse = (
    response: AxiosResponse,
    isPutawayUnitByUnit: ConfigurationSaga,
    event: React.KeyboardEvent<HTMLDivElement>
  ) => {
    const validatedSku = response.data as SkuAsnDetailValidated

    // Revisamos si tiene lote o fecha
    // Cualquierda de los dos true, debe levantar un popup
    // Que debe ir a buscar valores al backend y no ejecutar lo que viene abajo
    const { batchNumber, expirationDate, stockKeepingUnitId } = validatedSku

    if (batchNumber || expirationDate) {
      const skuId = stockKeepingUnitId

      // Constante para TTL del cache (5 minutos)
      const CACHE_TTL = 5 * 60 * 1000
      const now = Date.now()
      const isCacheTimeValid =
        state.currentBatchesTimestamp !== null &&
        now - state.currentBatchesTimestamp < CACHE_TTL &&
        state.currentBatches.length > 0

      let cacheBelongsToCurrentSku = false

      if (isCacheTimeValid) {
        // Tomamos un lote de muestra del caché
        const sampleBatch = state.currentBatches[0]

        // Intentamos validar si este lote corresponde al SKU actual (stockKeepingUnitId)
        if ((sampleBatch as any).skuId === skuId) {
          cacheBelongsToCurrentSku = true
        }
        // Esto cruza la información para asegurar que el lote en memoria es de este producto
        else if (state.item) {
          const matchingDetail = state.item.workOrderDetails.find(
            (d) => d.batchId === sampleBatch.batchId && d.skuId === skuId
          )
          if (matchingDetail) {
            cacheBelongsToCurrentSku = true
          }
        }
      }

      // El caché es válido SOLO SI está en tiempo Y pertenece al mismo SKU
      const cacheIsValid = isCacheTimeValid && cacheBelongsToCurrentSku

      // Función para decidir comportamiento FEFO según lotes disponibles
      const decideFefoBehavior = (availableBatches: Batch[]) => {
        const fefoType = {
          hasBatchNumber: batchNumber,
          hasExpirationDate: expirationDate,
          modalTitle:
            batchNumber && expirationDate
              ? 'Lotes y Vencimientos'
              : batchNumber
              ? 'Lotes'
              : 'Fechas de Vencimiento',
          modalType:
            batchNumber && expirationDate
              ? 'both'
              : batchNumber
              ? 'batch'
              : 'expiration'
        } as SkuFefoType

        // Decidir según cantidad de lotes disponibles después de filtros
        if (availableBatches.length === 0) {
          // No hay lotes disponibles
          dispatch(
            setInputError(
              'No hay lotes disponibles',
              'error',
              'setSkuEan',
              'skuEan'
            )
          )
        } else if (availableBatches.length === 1) {
          // Auto-seleccionar el único lote disponible
          addBatchInfoToState(availableBatches[0], isPutawayUnitByUnit)
        } else {
          // Mostrar modal con múltiples lotes
          dispatch(setSkuFefoType(fefoType))
          dispatch(setShowFefoModal(true))
        }
      }

      if (cacheIsValid) {
        // Usar cache existente, aplicando filtro de frontend
        const availableBatches = filterCompletedBatchesInFrontend(
          state.currentBatches
        )
        decideFefoBehavior(availableBatches)
      } else {
        // Fetch desde API con pageSize=500
        getAsnBatches(
          0,
          500,
          state.item?.asnId || 0,
          state.item?.workingLpn,
          '',
          skuId,
          [eBatchState.Created, eBatchState.Pending, eBatchState.Storing]
        )
          .then((apiResponse) => {
            const batchesFromApi = apiResponse.data.items || []

            // Guardar en cache con timestamp
            dispatch({
              type: 'setCurrentBatchesWithTimestamp',
              payload: {
                batches: batchesFromApi,
                timestamp: Date.now()
              }
            })

            // Aplicar filtro de frontend (excluir lotes completados en sesión actual)
            const availableBatches =
              filterCompletedBatchesInFrontend(batchesFromApi)

            decideFefoBehavior(availableBatches)
          })
          .catch(() => {
            dispatch(
              setInputError(
                'Error al obtener lotes',
                'error',
                'setSkuEan',
                'skuEan'
              )
            )
          })
      }
    } else {
      const wasEnterKeyPressed = event.key === 'Enter'
      addSkuLogic(isPutawayUnitByUnit, wasEnterKeyPressed)
    }
  }

  const addBatchInfoToState = (
    batch: Batch,
    isPutawayUnitByUnit: ConfigurationSaga
  ) => {
    dispatch(setBachList(batch))
    dispatch(setSelectedBatchId(batch.batchId))
    // llamamos al executeAddSkuLogic
    addSkuLogic(isPutawayUnitByUnit, true, batch.batchId)

    dispatch(setShowFefoModal(false))
  }

  const addSkuLogic = (
    isPutawayUnitByUnit: ConfigurationSaga,
    wasEnterKeyPressed: boolean,
    batchId?: number
  ) => {
    // En caso que sea request correcto
    //    -Escaneo unitario - va sumando unidades
    if (isPutawayUnitByUnit.value === 'true') {
      addOneToOneElementToSKUList(wasEnterKeyPressed, batchId)
    } else {
      // -Escaneo por cantidad  - esto hace focus a la cantidad
      dispatch(setInputError('', 'success', 'setSkuEan', 'skuEan'))
    }

    // Limpiar selectedBatchId si no se proporcionó batchId (SKU sin lote)
    if (batchId === undefined) {
      dispatch(setSelectedBatchId(undefined))
    }
  }

  const setIsShowNotification = (isShowNotification: boolean): actionTypes => ({
    type: 'setIsShowNotification',
    payload: isShowNotification
  })

  const setIsShowExcess = (isShowExcess: boolean): actionTypes => ({
    type: 'setIsShowExcess',
    payload: isShowExcess
  })

  const setIsExcess = (isExcess: boolean): actionTypes => ({
    type: 'setIsExcess',
    payload: isExcess
  })

  const setResetLocate = (): actionTypes => ({
    type: 'setResetLocate'
  })

  const handleResetLocate = () => {
    dispatch(setResetLocate())
    document.getElementById('skuEan')?.focus()
  }

  const setCalculatedExcess = (calculatedExcess: number): actionTypes => ({
    type: 'setCalculatedExcess',
    payload: calculatedExcess
  })

  const setCalculatedInbound = (calculatedInbound: number): actionTypes => ({
    type: 'setCalculatedInbound',
    payload: calculatedInbound
  })

  const setSkuLocated = (skuLocated: string): actionTypes => ({
    type: 'setSkuLocated',
    payload: skuLocated
  })

  const setIsPreSale = (isPreSale: boolean): actionTypes => ({
    type: 'setIsPreSale',
    payload: isPreSale
  })

  const countItemUnits = () => {
    return state.SkuListOnPosition.reduce(
      (total, current) => total + current.value,
      0
    )
  }

  const recalculateItems = () => {
    const skuRealQty =
      state.SkuListOnPosition.length === 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.filter(
            (x) => x.skuName === state.skuLocated
          )[0].realQty!
        : state.SkuListOnPosition.length > 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.reduce(
            (total, current) => total + current.realQty,
            0
          )
        : state.item?.workOrderDetails
            .filter((x) =>
              x.skuName.includes(
                state.SkuListOnPosition.map((x) => x.productName).toString()
              )
            )
            .reduce((total, current) => total + current.realQty, 0)

    const skuLocatedQty =
      state.SkuListOnPosition.length === 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.filter(
            (x) => x.skuName === state.skuLocated
          )[0].locatedQty!
        : state.SkuListOnPosition.length > 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.reduce(
            (total, current) => total + current.locatedQty,
            0
          )
        : state.item?.workOrderDetails
            .filter((x) =>
              x.skuName.includes(
                state.SkuListOnPosition.map((x) => x.productName).toString()
              )
            )
            .reduce((total, current) => total + current.locatedQty, 0)

    const difference = countItemUnits() - skuRealQty! + (skuLocatedQty! || 0)

    if (difference >= 0) {
      dispatch(
        setCalculatedExcess(difference + state.item?.excessUnitsQty! || 0)
      )
      dispatch(
        setCalculatedInbound(
          countItemUnits() + state.item?.locatedUnitsQty! - difference
        )
      )
    } else {
      dispatch(setCalculatedExcess(state.item?.excessUnitsQty! || 0))
      dispatch(
        setCalculatedInbound(countItemUnits() + state.item?.locatedUnitsQty!)
      )
    }
  }

  const setIsFlipped = (isFlipped: boolean, option: number): actionTypes => ({
    type: 'setIsFlipped',
    payload: { isFlipped, option }
  })

  const setWorkOrderSkuHistory = (
    workOrderSkuHistory: WorkOrderInboundSkuHistoryDetails[]
  ): actionTypes => ({
    type: 'setWorkOrderSkuHistory',
    payload: workOrderSkuHistory
  })

  const getWorkOrderSkuHistory = () => {
    dispatch(setLoadingHistory(true))
    const workingLpn =
      state.item?.workingLpn === null ? '' : `&Lpn=${state.item?.workingLpn}`
    apiCall(
      'GET',
      `${ApiConfig.InboundHistoryApi}?WorkOrderId=${state.item?.workOrderId}&UserId=${userData?.userId}${workingLpn}`
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderSkuHistory([]))
          dispatch(setError('No fue posbile obtener los datos', 'error'))
        } else {
          dispatch(setWorkOrderSkuHistory(response.data.details))
          dispatch(setError('', 'default'))
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderSkuHistory([]))
        dispatch(setError(message, 'error'))
      })
      .finally(() => {
        dispatch(setLoadingHistory(false))
      })
  }

  const putBloqUserLpn = () => {
    // Llama al metodo solo si esta desactivada la opcion "Permite más de un operador por LPN"
    const allowTwoUserOnTheSameLPN = configurationState.configuration.filter(
      (el) => el.name === 'AllowTwoUserOnTheSameLPN'
    )[0]

    if (userData?.userId === undefined) {
      return
    }

    if (
      allowTwoUserOnTheSameLPN.value === 'false' &&
      state.item?.workingLpn !== null
    ) {
      apiCall(
        'PUT',
        `${ApiConfig.AsnDetailBloqUserLpn}/${state.item?.asnId}?Lpn=${state.item?.workingLpn}&userId=${userData?.userId}` // se omite user id para desbloquear lpn (deja en null)
      )
        .then((response: AxiosResponse) => {
          if (response.status !== 200) {
            dispatch(
              setError(
                'No fue posbile actualizar detalle de asn para el bloqueo de usuario',
                'error'
              )
            )
          } else {
            dispatch(setError('', 'default'))
          }
        })
        .catch(({ data: { message } }) => {
          dispatch(setError(message, 'error'))
        })
    }
  }

  const handleFlipGetHistory = (option: FlipBackOptions) => {
    dispatch(setIsFlipped(true, option))
    getWorkOrderSkuHistory()
  }
  const setLoadingHistory = (loadingHistory: boolean): actionTypes => ({
    type: 'setLoadingHistory',
    payload: loadingHistory
  })

  const validateSkuUnknown = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    apiCall(
      'GET',
      `${ApiConfig.StockKeepingUnitApi}?SKU=${state.skuUnknown.value}`
    )
      .then((response) =>
        response.data.items.length > 0
          ? dispatch(
              setInputError('', 'success', 'setSkuUnknown', 'skuUnknown')
            )
          : dispatch(
              setInputError(
                'SKU no es válido',
                'error',
                'setSkuUnknown',
                'skuUnknown'
              )
            )
      )
      .catch(({ data: { message } }) => {
        dispatch(setError(message, 'error'))
      })
  }

  const existsExcessOnVIew = () => {
    // traerme todos los SKU (skuid, cantidad real, locatedqty)
    const allSku = (state.item?.workOrderDetails || [])
      .filter((x) => x.lpn === state.item?.workingLpn)
      .map(({ skuId, realQty, locatedQty, batchId }) => {
        // Buscar elementos en SkuListOnPosition que coincidan con skuId y batchId
        const matchingItems = state.SkuListOnPosition.filter((f) => {
          if (batchId !== undefined && batchId !== null) {
            // Si el workOrderDetail tiene batchId, buscar elementos con el mismo skuId y batchId
            return f.skuId === skuId && f.batchId === batchId
          } else {
            // Si el workOrderDetail no tiene batchId, buscar elementos sin batchId
            return (
              f.skuId === skuId &&
              (f.batchId === undefined || f.batchId === null)
            )
          }
        })

        // Sumar todas las cantidades de los elementos que coinciden
        const totalInPosition = matchingItems.reduce(
          (sum, item) => sum + item.value,
          0
        )

        return {
          skuId,
          batchId,
          total: realQty - (locatedQty || 0) - totalInPosition
        }
      })

    return allSku.filter((f) => f.total < 0).length > 0
  }

  const getConfigAllowTwoUserOnTheSameLPN = () => {
    // Llama al metodo solo si esta desactivada la opcion "Permite más de un operador por LPN"
    const allowTwoUserOnTheSameLPN = configurationState.configuration.filter(
      (el) => el.name === 'AllowTwoUserOnTheSameLPN'
    )[0]

    return !allowTwoUserOnTheSameLPN.value
  }

  const PatchLpnState = () => {
    dispatch(setLoading(true))
    apiCall(
      'PATCH',
      `${ApiConfig.AsnDetailUpdateLpnState}/${state.item?.asnId}`,
      {
        lpn: state.item?.workingLpn,
        validateState: true // indica al back que evalue que estado debe asignar dependiendo de sus detalles.
      }
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(
            setError(
              'No fue posbile actualizar el estado de la LPN a finalizada',
              'error'
            )
          )
        } else {
          state.isSelected = 'WorkOrderId'
          state.searchValue = state.item?.workOrderId.toString() || ''
          getWorkOrderLocate()
          dispatch(setStep(stepperTypes.stepLPNSelection))
          dispatch(setError('', 'default'))
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setError(message, 'error'))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const clearUbication = () => {
    dispatch(setInputData('', '', 'success', 'setInputQty'))
  }

  const checkPositionByType = useCallback(
    async (typePositionId: number): Promise<boolean> => {
      try {
        const response = await apiCall(
          'GET',
          `${ApiConfig.PositionApi}?TypePositionId=${typePositionId}`
        )

        if (response.status !== 200) {
          return false
        }

        const hasPositions =
          response.data &&
          (Array.isArray(response.data.items)
            ? response.data.items.length > 0
            : response.data.totalItems?.length > 0)

        return hasPositions
      } catch (error) {
        console.error('Error checking positions:', error)
        return false
      }
    },
    []
  )

  return {
    resetButtonFilter,
    setSearch,
    setSearchValue,
    getWorkOrderLocate,
    setWorkOrderLocate,
    mapperSearchOptions,
    setItem,
    setStep,
    validateStep,
    validateStepBack,
    setResetState,
    mapperDetailsOptions,
    handleChangeGenericInput,
    handleResetGenericInput,
    expandCollapseHeaderAndGrid,
    setInputError,
    validatePosition,
    setDefaultStatusInput,
    setViewField,
    addItemList,
    removeItemList,
    handleRemoveItemFromList,
    addElementToSKUList,
    validateSKUInput,
    terminateLocateAsn,
    setIsShowNotification,
    handleResetLocate,
    countItemUnits,
    recalculateItems,
    setIsExcess,
    handleResetPage,
    handleSetUserId,
    setIsShowExcess,
    setIsFlipped,
    setIsPreSale,
    getWorkOrderSkuHistory,
    handleFlipGetHistory,
    setIsUnknownScreen,
    setUnknownFilter,
    validateSkuUnknown,
    setOriginsUnknown,
    setSuppliersUnknown,
    setTitlteDocsMatch,
    setError,
    getWorkOrderLocateByLpn,
    addOneToOneElementToSKUList,
    putBloqUserLpn,
    existsExcessOnVIew,
    getConfigAllowTwoUserOnTheSameLPN,
    PatchLpnState,
    clearUbication,
    setShowFefoModal,
    addBatchInfoToState,
    setSelectedBatchId,
    setBachList,
    getSkuIdFromElegibleProducts,
    checkBatchCompletionWithNewQty,
    handleBatchCompletion,
    setShowBatchCompletedModal,
    setCompletedBatchInfo,
    resetNotifiedCompletedBatches,
    removeNotifiedCompletedBatch,
    checkPositionByType,
    filterCompletedBatchesInFrontend,
    setHeaderParamSearch
  }
}
